import { render } from "./EditLessonPage.vue?vue&type=template&id=0709cab6&scoped=true"
import script from "./EditLessonPage.vue?vue&type=script&lang=js"
export * from "./EditLessonPage.vue?vue&type=script&lang=js"

import "./EditLessonPage.vue?vue&type=style&index=0&id=0709cab6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0709cab6"]])

export default __exports__